module.exports = "/fonts/materialdesignicons-webfont.woff?63d2a5950fc212096c3612f71ae66f64";